export default __webpack_public_path__ + "static/media/15.edf2a6a8.jpg";